import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'ng-template[colHeaderTemplate]'
})
export class ColumnHeaderTemplateDirective {
    @Input('colHeaderTemplate') name: string;

    constructor(public template: TemplateRef<any>) {}
}
